<template>
    <portal>
        <div class="mb-8 d-flex align-center">
            <v-icon color="primary" size="30">mdi-chart-pie</v-icon>
            <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Portfolio Allocator</h1>
        </div>

        <div class="portfolio-allocator-list" v-if="portfolioAllocator == null">
            <v-btn color="primary" @click="allocatorModalOpen = true">
                Create Portfolio Allocator
                <v-dialog
                    v-model="allocatorModalOpen"
                    activator="parent"
                    width="800px"
                >
                    <portfolio-allocator-form
                        @portfolio-allocator-created="allocatorModalOpen = false"
                        @portfolio-allocator-cancelled="allocatorModalOpen = false"
                    ></portfolio-allocator-form>
                </v-dialog>
            </v-btn>

            <v-card  class="mt-5" variant="outline" v-for="pa in portfolioAllocators" :key="pa.id + pa.name">
                <portfolio-allocator-form
                    :portfolio-allocator-prop="pa"
                    @run-allocator="runAllocator"></portfolio-allocator-form>
            </v-card>
        </div>

        <div class="portfolio-allocator" v-if="portfolioAllocator">
            <v-btn color="primary" @click="portfolioAllocator = null">Go Back</v-btn>
            <h2 class="mt-2 mb-2">{{ portfolioAllocator.name }}</h2>
            <iframe :src="portfolioAllocatorUrl" style="width: 100%; height: 1200px;"></iframe>
        </div>
    </portal>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import axios from "axios";
import Portal from "@/components/Portal";
import PortfolioAllocatorForm from "@/components/portfolio-allocator/PortfolioAllocatorForm";
import PortfolioAllocator from "@/store/models/PortfolioAllocator";
export default  {
    name: 'Portfolios',

    components: {
        Portal,
        PortfolioAllocatorForm
    },

    computed: {
        ...mapState('auth', [
            'portfolios',
            'user'
        ]),

        ...mapGetters('auth', [
            'getPortfolioIdByCategoryAndRisk'
        ]),

        ...mapState('company', [
            'company'
        ]),

        portfolioAllocators() {
            return PortfolioAllocator.query().orderBy('id', 'desc').get();
        },

        portfolioId() {
            if (this.portfolioAllocator) {
                return this.getPortfolioIdByCategoryAndRisk(this.portfolioAllocator.name_category, this.portfolioAllocator.risk_category);
            }

            return null;
        },

        portfolioAllocatorUrl() {
            if (this.portfolioAllocator) {
                return this.$api_url + '/portfolios/' + this.portfolioId + '/allocator?pa=' + this.portfolioAllocator.id;
            }

            return null;
        },

        portfolioOptions() {
            let series = [
                'All Seasons Smart Beta',
                'All Seasons Smart Beta ETF',
                'All Seasons Smart Rotation',
                'Alpha Seekers'
            ]

            let options = [];

            for (let i = 0; i < series.length; i++) {
                options.push({header: series[i]});

                let regex = new RegExp('(?<=' + series[i] + ' ' + ')\\d', 'g');

                this.portfolios.forEach((portfolio) => {
                    let matches = portfolio.title.match(regex);

                    if (matches) {
                        options.push({risk: matches[0], id: portfolio.id, title: portfolio.title})
                    }
                })
            }

            return options;
        }
    },

    data: function () {
        return {
            allocatorModalOpen: false,
            portfolioAllocator: null
        }
    },

    mounted() {
        PortfolioAllocator.fetchUserPortfolioAllocators(this.user.id);
        axios.get( '/api/pa-portfolios').then((r) => {
            this.setPortfolios(r.data.data.portfolios);
        })
    },

    methods: {
        ...mapActions('auth', ['updateUserData']),
        ...mapMutations('auth', ['setPortfolios']),
        runAllocator(portfolioAllocator) {
            this.portfolioAllocator = portfolioAllocator
        }
    },

    watch: {
        portfolioId(newValue, oldValue) {
            if (oldValue !== null) {
                this.updateUserData({portal_portfolio_id: newValue});
            }
        }
    }
}
</script>
